"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = void 0;
// eslint-disable-next-line no-new-func
exports.isBrowser = new Function('try { return this === window; } catch(e) { return false; }');
//# sourceMappingURL=constants.js.map